import React, { FunctionComponent } from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import ArtPieceSharedDetails from "./SharedDetails"

const ArtPiecePainting: FunctionComponent = () => {
  return (
    <div className="container">
      <ArtPieceSharedDetails />
      <div className="row">
        <div className="col-6">
          <FormInput
            name="painting.width"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Width"
          />
        </div>
        <div className="col-6">
          <FormInput
            name="painting.height"
            label="Height"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ArtPiecePainting
